import { I18n } from "Utils/types";

export const COPY_LABEL: I18n = {
    en: "copied!",
    he: "הועתק!",
}